import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EditSkusModal from './EditSkusModal';
import { css } from 'react-emotion';
import { colors, Icon } from '@cimpress/react-components';
import Button from '../../common/Button';
import { withTranslation } from 'react-i18next';

const linkTextStyle = css`
  color: ${colors.ocean.base};
  margin-left: 10px;
  margin-right: 5px;
`;

class EditSkusButton extends PureComponent {
  static propTypes = {
    termRevision: PropTypes.object.isRequired,
    setLatestRevision: PropTypes.func.isRequired,
    items: PropTypes.object.isRequired,
    firstItemPriceModel: PropTypes.object.isRequired
  };

  state = {
    editModalOpened: false,
    termItems: {}
  };

  onOpenEditSkusModal = () => {
    this.setState({ editModalOpened: true });
  };

  onCloseEditSkusModal = () => {
    this.setState({ editModalOpened: false });
  };

  render() {
    const { editModalOpened } = this.state;
    const { t, termRevision, setLatestRevision, items, firstItemPriceModel } = this.props;

    return (
      <React.Fragment>
        <Button bsStyle="link" onClick={this.onOpenEditSkusModal}>
          <small className={linkTextStyle}>{t('common:commonWords.edit')}</small>
          <Icon name="pencil-2-l" color={colors.ocean.base} />
        </Button>
        {editModalOpened && (
          <EditSkusModal
            editModalOpened={editModalOpened}
            onCloseEditSkusModal={this.onCloseEditSkusModal}
            termRevision={termRevision}
            setLatestRevision={setLatestRevision}
            skusMap={items}
            priceModel={firstItemPriceModel}
          />
        )}
      </React.Fragment>
    );
  }
}

export default withTranslation()(EditSkusButton);
